export default __webpack_public_path__ + "static/media/icon10.434950a8.svg";